// Drives the display order and titles for the "life" analytics buckets
// shown on the Sender Transactions page. Add/remove/reorder entries here —
// no component changes needed.
export const TRANSACTIONS_ANALYTICS_CONFIG = [
  { key: "success", title: "Sent" },
  { key: "pending", title: "Pending", valueClassName: "text-orange-500" },
  { key: "created", title: "Created" },
  { key: "failed", title: "Failed", valueClassName: "text-red-500" },
  { key: "rejected", title: "Rejected", valueClassName: "text-red-500" },
];
export const TREASURY_ANALYTICS_CONFIG = [
  { amountKey: "amount", countKey: "count", title: "Total Volume" },
  { amountKey: "inAmount", countKey: "inCount", title: "Money In", valueClassName: "text-green-600" },
  { amountKey: "outAmount", countKey: "outCount", title: "Money Out", valueClassName: "text-red-500" },
];



export const INVOICE_ANALYTICS_CONFIG = [
  { key: "open", title: "Open" },
  { key: "paid", title: "Paid" },
  { key: "outStanding", title: "Outstanding" },
  { key: "pending", title: "Pending" ,valueClassName: "text-orange-500"},
  { key: "failed", title: "Failed" ,valueClassName: "text-red-500"},
  { key: "rejected", title: "Rejected" ,valueClassName: "text-red-500"},
  {key: "overDueCount", title: "Overdue Count" ,valueClassName: "text-orange-500"},
];